import { Account } from '@ndvr/portfolio-api';

import {
    AccountGroupProfileWithAumIncluded,
    useAccountGroupProfileWithAumIncluded,
} from 'views/portfolio/account-aum-queries';
import { useAccount } from 'views/portfolio/account-queries';
import { getPolicyAccounts } from 'views/portfolio/policy-coordination';

import { PolicyRetryQuery } from './PolicyQueryError';

export type PolicyScope =
    | {
          status: 'ready';
          account: Account;
          profile: AccountGroupProfileWithAumIncluded;
          accounts: Account[];
          retryQueries: PolicyRetryQuery[];
      }
    | { status: 'loading' | 'error'; account?: Account; accounts: []; retryQueries: PolicyRetryQuery[] };

/** The accounts an investment policy covers: the account alone, or every managed account it is coordinated with. */
export const usePolicyScope = (accountGUID: string, accountGroupGUID: string): PolicyScope => {
    const accountQuery = useAccount(accountGUID, { throwOnError: false });
    const profileQuery = useAccountGroupProfileWithAumIncluded(accountGroupGUID, { throwOnError: false });
    const account = accountQuery.data;
    const profile = profileQuery.data;
    const retryQueries = [accountQuery, profileQuery];
    if (account && profile) {
        return { status: 'ready', account, profile, accounts: getPolicyAccounts(account, profile), retryQueries };
    }
    const failed = accountQuery.isLoadingError || profileQuery.isLoadingError;
    const pending = accountQuery.isPending || profileQuery.isPending;
    return { status: failed || !pending ? 'error' : 'loading', account, accounts: [], retryQueries };
};
